<template>
  <v-row>
    <v-col cols="12" v-text="$route.name" class="mt-5 grey--text text-h2" />
    <v-col cols="12">
      <v-card class="pa-3" outlined>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="processolocal.nome" label="Nome" required />
          <v-row>
            <!--Data-Inicio-->
            <v-col cols="6">
              <v-menu
                v-model="Data_Inicio"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="DateFormattedInicio"
                    label="Data Início"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="processolocal.data_inicio"
                  locale="pt-br"
                  @input="Data_Inicio = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!--Data-Inicio          Fim-->
            <!--Data-Encerramento-->
            <v-col cols="6">
              <v-menu
                v-model="Data_Encerramento"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="DateFormattedEncerramento"
                    label="Data Encerramento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="processolocal.data_encerramento"
                  locale="br-pt"
                  @input="Data_Encerramento = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <!--Data-Encerramento    Fim-->
          </v-row>
          <v-col cols="12" class="d-flex justify-center">
            <CPTBtn
              label="Salvar"
              @click="onSubmit()"
              icon="mdi-content-save"
            />
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CPTBtn from "@/components/Btn.vue";
import { isBefore } from "date-fns";

export default {
  components: {
    CPTBtn
  },
  props: {
    processo: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    processolocal: {},
    Data_Inicio: false,
    modal: false,
    Data_Encerramento: false
  }),

  computed: {
    DateFormattedInicio() {
      return this.formatDate(this.processolocal.data_inicio);
    },
    DateFormattedEncerramento() {
      return this.formatDate(this.processolocal.data_encerramento);
    }
  },

  mounted() {
    this.processolocal = this.processo?.id ? { ...this.processo } : {};
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    cadastrarProcesso() {
      this.$http
        .post("/processo-inscricao", this.processolocal)
        .then(() => {
          this.showMessage("Processo cadastrado com sucesso", "success");
          this.$router.push("/processos");
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    },
    editarProcesso() {
      this.$http
        .put(`/processo-inscricao/${this.processolocal.id}`, this.processolocal)
        .then(() => {
          this.showMessage("Processo alterado com sucesso", "success");
          this.$router.push("/processos");
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        const dataValida = isBefore(
          new Date(this.processolocal.data_inicio),
          new Date(this.processolocal.data_encerramento)
        );

        if (!dataValida) {
          return this.showMessage(
            "Data Início não pode ser maior que o Data Encerramento! por favor verificar novamente.",
            "error"
          );
        }

        this.loading = true;
        this.processolocal.id
          ? this.editarProcesso()
          : this.cadastrarProcesso();
      } else {
        this.showMessage("Verifique os campos obrigatórios", "error");
      }
    }
  }
};
</script>
